import React from 'react';

import Home from 'features/marketing/home/Home';
import Exchanges from 'features/exchanges/Exchanges';
import Services from 'features/services/services';
import VIP from 'features/services/vip/vip';
import Payment from 'features/services/vip/payment/payment';
import Indicator from 'features/services/indicator/indicator';
import IndicatorPayment from 'features/services/indicator/payment/indicatorPayment';
import CopyTrading from 'features/services/copy-trading/copyTrading';
import CopyTradingGuide from 'features/services/copy-trading/guide/copy-trading-guide';
import CopyBlofin from 'features/services/copy-trading/k';
import Koala from 'features/services/copy-trading/Koala';
import Portfolio from 'features/services/portfolio/portfolio';
import BlofinGuide from 'features/affiliates/blofin/blofinguide';
import TradersNotes from 'features/affiliates/tradersnotes/tradersnotes';
import BitcoinOg from 'features/affiliates/blofinAff/bitcoin_og';
import EthereumUs from 'features/affiliates/blofinAff/ethereum_us';
import CryptoPages from 'features/affiliates/blofinAff/cryptoPages';
import AltcoinCryptos from 'features/affiliates/blofinAff/altcoinCryptos';
import NftGlobally from 'features/affiliates/blofinAff/nftGlobally';
import SolanaCoins from 'features/affiliates/blofinAff/solanaCoins';
import TrxCryptos from 'features/affiliates/blofinAff/trxCryptos';
import XrpCryptos from 'features/affiliates/blofinAff/xrpCryptos';
import About from 'features/marketing/about/About';
import Contact from 'features/marketing/contact/Contact';
import FAQ from 'features/marketing/faq/faq';
import Terms from 'features/legal/terms-and-conditions/terms';
import Risk from 'features/legal/risk-disclosure/risk';
import Leaderboard from 'features/marketing/competition/leaderboard';
import Results from 'features/marketing/results/results';
import AdminChat from 'features/internal/admin/admin';
import Testing from 'features/internal/testing/testing';
import Survey from 'features/internal/survey/uid';
import P23nse from 'features/internal/tracking-redirect/23nse';
import CryptoEducation from 'features/crypto-education/CryptoEducation';

export const HIDDEN_NAVBAR_PREFIXES = ['/admin', '/survey', '/crypto-education'];

const withNavbarHeight = (Component) => ({ navbarHeight }) => (
  <Component navbarHeight={navbarHeight} />
);

const withoutNavbarHeight = (Component) => () => <Component />;

export const appRoutes = [
  {
    path: '/partners',
    component: 'Exchanges',
    status: 'active',
    layout: 'standard navbar',
    render: withoutNavbarHeight(Exchanges),
  },
  {
    path: '/exchanges',
    component: 'Exchanges',
    status: 'alias',
    layout: 'standard navbar',
    render: withoutNavbarHeight(Exchanges),
  },
  {
    path: '/',
    component: 'Home',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(Home),
  },
  {
    path: '/vip',
    component: 'VIP',
    status: 'alias',
    layout: 'standard navbar',
    render: withNavbarHeight(VIP),
  },
  {
    path: '/services',
    component: 'Services',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(Services),
  },
  {
    path: '/services/vip',
    component: 'VIP',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(VIP),
  },
  {
    path: '/services/vip/payment',
    component: 'Payment',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(Payment),
  },
  {
    path: '/services/copy-trading',
    component: 'CopyTrading',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(CopyTrading),
  },
  {
    path: '/copy-trading',
    component: 'CopyTrading',
    status: 'alias',
    layout: 'standard navbar',
    render: withNavbarHeight(CopyTrading),
  },
  {
    path: '/indicator',
    component: 'Indicator',
    status: 'alias',
    layout: 'standard navbar',
    render: withNavbarHeight(Indicator),
  },
  {
    path: '/services/copy-trading/guide',
    component: 'CopyTradingGuide',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(CopyTradingGuide),
  },
  {
    path: '/blofin-guide',
    component: 'BlofinGuide',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(BlofinGuide),
  },
  {
    path: '/services/indicator',
    component: 'Indicator',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(Indicator),
  },
  {
    path: '/services/indicator/payment',
    component: 'IndicatorPayment',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(IndicatorPayment),
  },
  {
    path: '/services/portfolio',
    component: 'Portfolio',
    status: 'restored',
    layout: 'standard navbar',
    render: withNavbarHeight(Portfolio),
  },
  {
    path: '/portfolio',
    component: 'Portfolio',
    status: 'alias',
    layout: 'standard navbar',
    render: withNavbarHeight(Portfolio),
  },
  {
    path: '/about',
    component: 'About',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(About),
  },
  {
    path: '/contact',
    component: 'Contact',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(Contact),
  },
  {
    path: '/faq',
    component: 'FAQ',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(FAQ),
  },
  {
    path: '/terms&conditions',
    component: 'Terms',
    status: 'preserved legacy',
    layout: 'standard navbar',
    render: withoutNavbarHeight(Terms),
  },
  {
    path: '/risk-disclosure',
    component: 'Risk',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(Risk),
  },
  {
    path: '/competition',
    component: 'Leaderboard',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(Leaderboard),
  },
  {
    path: '/results',
    component: 'Results',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(Results),
  },
  {
    path: '/services/copy-trading/blofin',
    component: 'CopyBlofin',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(CopyBlofin),
  },
  {
    path: '/admin',
    component: 'AdminChat',
    status: 'internal',
    layout: 'navbar hidden',
    render: withoutNavbarHeight(AdminChat),
  },
  {
    path: '/tradersnotes',
    component: 'TradersNotes',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(TradersNotes),
  },
  {
    path: '/affiliate/bitcoin_og',
    component: 'BitcoinOg',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(BitcoinOg),
  },
  {
    path: '/affiliate/ethereum_us',
    component: 'EthereumUs',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(EthereumUs),
  },
  {
    path: '/affiliate/crypto_pages',
    component: 'CryptoPages',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(CryptoPages),
  },
  {
    path: '/affiliate/altcoin_cryptos',
    component: 'AltcoinCryptos',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(AltcoinCryptos),
  },
  {
    path: '/affiliate/nft_globally',
    component: 'NftGlobally',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(NftGlobally),
  },
  {
    path: '/affiliate/solana_coins',
    component: 'SolanaCoins',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(SolanaCoins),
  },
  {
    path: '/affiliate/trx_cryptos',
    component: 'TrxCryptos',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(TrxCryptos),
  },
  {
    path: '/affiliate/xrp_cryptos',
    component: 'XrpCryptos',
    status: 'active',
    layout: 'standard navbar',
    render: withNavbarHeight(XrpCryptos),
  },
  {
    path: '/oaskdojfiojandjknf',
    component: 'Testing',
    status: 'internal',
    layout: 'standard navbar',
    render: withoutNavbarHeight(Testing),
  },
  {
    path: '/home',
    component: 'P23nse',
    status: 'tracking',
    layout: 'standard navbar',
    render: withoutNavbarHeight(P23nse),
  },
  {
    path: '/survey',
    component: 'Survey',
    status: 'internal',
    layout: 'navbar hidden',
    render: withoutNavbarHeight(Survey),
  },
  {
    path: '/koala',
    component: 'Koala',
    status: 'preserved legacy',
    layout: 'standard navbar',
    render: withNavbarHeight(Koala),
  },
  {
    path: '/crypto-education',
    component: 'CryptoEducation',
    status: 'active',
    layout: 'navbar hidden',
    render: withoutNavbarHeight(CryptoEducation),
  },
  {
    path: '/crypto-education/:variantSlug',
    component: 'CryptoEducation',
    status: 'active',
    layout: 'navbar hidden',
    render: withoutNavbarHeight(CryptoEducation),
  },
];
